import { useContext } from 'react';
import { AuthBundle, AuthContext } from '../context/auth.context';

const useAuth = (): AuthBundle => {
    const authBundle = useContext(AuthContext);
    return authBundle;
};

export default useAuth;